<template>
  <div class="meeting-box safe-distance-top-header-two">
    <Header pageTitle="我的会议" />
    <div class="meeting-box-bottm">
      <div class="van_tabs">
        <van-tabs
          v-model="active"
          color="#397BF9"
          title-active-color="#397BF9"
          @change="tabChange"
        >
          <van-tab title="我参与的" name="0">
            <participated />
          </van-tab>
          <van-tab title="我报名的" name="1">
            <application />
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import participated from "./participated.vue";
import application from "./application.vue";
import Header from "@/views/mobileView/components/header";
export default {
  name: "meeting-box",
  components: {
    participated,
    application,
    Header
  },
  data() {
    return {
      active: 0,
    };
  },
  created() {
    this.active = this.$route.query.active ? this.$route.query.active : "0";
  },
  methods: {
    // 切换tab标签，查询不同类型订单列表 name：标识符，title：标题
    tabChange(name, title) {
      console.log(name, "name");
      switch (name) {
        // 查询全部
        case "0":
          this.$router.replace({ path: this.$route.path });
          break;
        // 查询待付款
        case "1":
          this.$router.replace({
            path: this.$route.path,
            query: { active: 1 },
          });
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.meeting-box {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: #f5f5f5;
  .meeting-box-bottm {
    width: 100%;
    height: 100%;
    &::v-deep .van-tabs__wrap {
      margin-bottom: 12px;
    }
  }
}
</style>
